export default "__VITE_ASSET__BNo09L_E__"